// Copyright (c) 2017 Deere & Company

export default Object.freeze({
    PRODUCT_REGISTRATION_REGISTER_ANOTHER_PRODUCT: 'PRODUCT_REGISTRATION_REGISTER_ANOTHER_PRODUCT',
    RESET_PRODUCT_REGISTRATION: 'RESET_PRODUCT_REGISTRATION',
    RESET_PRODUCT_REGISTRATION_FORM_VALIDATION: 'RESET_PRODUCT_REGISTRATION_FORM_VALIDATION',
    UPDATE_PRODUCT_REGISTRATION: 'UPDATE_PRODUCT_REGISTRATION',
    UPDATE_PRODUCT_REGISTRATION_FORM_VALIDATION: 'UPDATE_PRODUCT_REGISTRATION_FORM_VALIDATION',
    UPDATE_PRODUCT_REGISTRATION_MODALS: 'UPDATE_PRODUCT_REGISTRATION_MODALS',
    UPDATE_PRODUCT_REGISTRATION_PRINT_REGISTRATION_MODAL: 'UPDATE_PRODUCT_REGISTRATION_PRINT_REGISTRATION_MODAL',
    UPDATE_PRODUCT_REGISTRATION_PRODUCT: 'UPDATE_PRODUCT_REGISTRATION_PRODUCT',
    UPDATE_PRODUCT_REGISTRATION_REGISTRATION: 'UPDATE_PRODUCT_REGISTRATION_REGISTRATION',
    UPDATE_PRODUCT_REGISTRATION_REGISTRATION_LOCATION: 'UPDATE_PRODUCT_REGISTRATION_REGISTRATION_LOCATION',
    UPDATE_PRODUCT_REGISTRATION_REGISTRATION_OTHER_USE_AMOUNT: 'UPDATE_PRODUCT_REGISTRATION_REGISTRATION_OTHER_USE_AMOUNT',
    UPDATE_PRODUCT_REGISTRATION_REGISTRATION_PIN: 'UPDATE_PRODUCT_REGISTRATION_REGISTRATION_PIN',
    UPDATE_PRODUCT_REGISTRATION_REGISTRATION_USE_AMOUNT: 'UPDATE_PRODUCT_REGISTRATION_REGISTRATION_USE_AMOUNT',
    UPDATE_PRODUCT_REGISTRATION_STATUS_CHANGE_MODAL: 'UPDATE_PRODUCT_REGISTRATION_STATUS_CHANGE_MODAL',
    UPDATE_REGISTRATION_PREVIOUS_DELIVERY_DATE: 'UPDATE_REGISTRATION_PREVIOUS_DELIVERY_DATE'
});



// WEBPACK FOOTER //
// ./src/product/product-registration/actions-list.js